import { render, staticRenderFns } from "./AddMatch.vue?vue&type=template&id=16e12a9c&scoped=true"
import script from "./AddMatch.vue?vue&type=script&lang=js"
export * from "./AddMatch.vue?vue&type=script&lang=js"
import style0 from "./AddMatch.vue?vue&type=style&index=0&id=16e12a9c&prod&scoped=true&lang=css"
import style1 from "./AddMatch.vue?vue&type=style&index=1&id=16e12a9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e12a9c",
  null
  
)

export default component.exports